<template lang="pug">
v-app
  v-main
    k-alert-blog Check out our #[nuxt-link(to="/articles").brand-pink--text new blog] featuring articles from our favourite advisors
    slot(name="before-header")
    the-header
    slot(name="after-header")
    slot(name="nuxt")
      nuxt
    slot(name="before-footer")
    div(:class="{ 'banner' : bannerMargin }")
      component(v-if="pageDisplaysBanner" :is="banners[0]")
    the-footer(:class="{ 'the-footer--no-banner' : footerHasMargin }")
    slot(name="after-footer")
    k-booking-modal-reminder(v-if="showBookingModal && !onReviewPage" v-model="showBookingModal")
    k-booking-modal-review(v-else-if="showReviewModal && !onReviewPage" v-model="showReviewModal")
</template>

<script>
import { get } from 'vuex-pathify'
import { ChecksLoggedIn, UsesAuthenticatedUser } from '@/mixins'
import { shuffle } from 'lodash'
import { TheFooter, TheHeader } from '~/layouts/components'
import KTourBecomeAdvisor from '~components/Tour/KTourBecomeAdvisor'
import KTourRewards from '~components/Tour/KTourRewards'

export default {
  components: {
    KTourRewards,
    KTourBecomeAdvisor,
    TheFooter,
    TheHeader,
  },
  mixins: [ ChecksLoggedIn, UsesAuthenticatedUser ],
  data () {
    return {
      showBookingModal: false,
      showReviewModal: false,
    }
  },
  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
      awaitingBookingReview: 'myKintell/awaitingBookingReview'
    }),
    onReviewPage () {
      return this.$route.name === 'my-kintell-bookings-id-review'
    },
    banners () {
      const banners = [ KTourRewards ]
      // add this banner if user is not an advisor
      if (!(this.userIsAuthenticated && this.authenticatedUserIsAdvisor) && this.$route.path !== '/become-an-advisor') {
        banners.push(KTourBecomeAdvisor)
      }
      return shuffle(banners)
    },
    // no banner margin if there is something in the beforeFooter slot
    bannerMargin () {
      return !this.$slots['before-footer'] && this.$route.path !== '/'
    },
    pageDisplaysBanner () {
      return this.$route.path === '/search' || // on the search page
        this.$route.path === '/' || // on home page
        this.$route.name === 'advisors-advisor-kintellCard' ||
        this.$route.path === '/become-an-advisor'
    },
    footerHasMargin () {
      // home page never has margin, otherwise check banners
      return !this.pageDisplaysBanner &&
        this.$route.path !== '/' &&
        this.$route.path !== '/code-of-conduct' &&
        this.$route.path !== '/become-an-advisor' &&
        this.$route.path !== '/pricing' &&
        !this.$slots['before-footer']
    }
  },
  mounted () {
    Object.entries({
      awaitingBookingSession: 'showBookingModal',
      awaitingBookingReview: 'showReviewModal'
    }).forEach(([ prop, data ]) => {
      this.$watch(prop, val => {
        if (val) {
          setTimeout(() => {
            this[data] = true
          }, 2000)
        }
      }, { immediate: true })
    })
  },
  head () {
    const onHomePage = this.$route.path === '/'
    return {
      script: onHomePage || window.Stripe ? [] : [
        { hid: 'stripe', src: 'https://js.stripe.com/v3/', async: true, defer: true, body: true },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.banner {
  margin-top: 80px;

  @include sm-and-down {
    margin-top: 40px;
  }
}

.v-main {
  box-shadow: 0 15px 35px rgba(48, 50, 75, .03);
  margin: 0 auto;
  width: 1440px;
}

.the-footer {
  &--no-banner {
    margin-top: 80px;

    @include sm-and-down {
      margin-top: 40px;
    }
  }
}
</style>
